import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import Head from '../../components/Partials/Head/Head';
import Auxiliary from '../../hoc/Auxiliary';
import TextGroup from '../../components/TextGroup/TextGroup';
import ProductBanner from '../../components/ProductBanner/ProductBanner';
import ProductSection from '../../components/ProductSection/ProductSection';
import DetailsCards from '../../components/DetailsCards/DetailsCards';
class Carshare extends Component {

  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="carshare" />
        <ProductBanner imgPadding {...this.props} page="carshare" />
        <ProductSection noPadBottom {...this.props} page="carshare" section="functionalities">
          <TextGroup noBtnPadding {...this.props} page="carshare" section="functionalities" />
        </ProductSection>
        <ProductSection noPadBottom {...this.props} page="carshare" section="benefits">
          <TextGroup {...this.props} page="carshare" section="benefits" />
        </ProductSection>
        <ProductSection {...this.props} page="carshare" section="details">
          <DetailsCards {...this.props} page="carshare" section="details" category="products" />
          <TextGroup noPadBottom {...this.props} page="carshare" section="demo" />
        </ProductSection>
      </Auxiliary>
    )
  }
}

export default withTranslation()(Carshare);